var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOngoingProjectEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 634133"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 634149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 634000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170",
    x: 68.0107,
    y: 37.2043,
    width: 32.0855,
    height: 43.9882,
    rx: 5.35484,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167",
    x: 72.6683,
    y: 63.4697,
    width: 23.2879,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173",
    x: 72.6683,
    y: 69.717,
    width: 23.2879,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172",
    x: 72.4731,
    y: 54.1613,
    width: 23.2043,
    height: 7.13978,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171",
    x: 72.4731,
    y: 39.8817,
    width: 10.7097,
    height: 10.7097,
    rx: 5.35484,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634001"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170_2",
    x: 10,
    y: 37.2043,
    width: 32.0855,
    height: 43.9882,
    rx: 5.35484,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167_2",
    x: 26.0645,
    y: 45.2366,
    width: 12.4946,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172_2",
    x: 13.5699,
    y: 54.1613,
    width: 24.9892,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173_2",
    x: 13.5699,
    y: 59.5161,
    width: 24.9892,
    height: 2.67742,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3174",
    x: 13.5699,
    y: 64.871,
    width: 24.9892,
    height: 7.13978,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171_2",
    x: 13.7651,
    y: 40.7742,
    width: 10.7097,
    height: 10.7097,
    rx: 5.35484,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.267 28.2796C76.6782 28.8961 81.3979 33.1088 81.3979 48.7608V69.3105C81.3979 83.0103 78.5717 89.8602 64.4409 89.8602H47.4839C33.3531 89.8602 30.5269 83.0103 30.5269 69.3105V48.7608C30.5269 33.143 35.2466 28.8961 44.6577 28.2796",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.267 28.2796C76.6782 28.8961 81.3979 33.1088 81.3979 48.7608V69.3105C81.3979 83.0103 78.5717 89.8602 64.4409 89.8602H47.4839C33.3531 89.8602 30.5269 83.0103 30.5269 69.3105V48.7608C30.5269 33.143 35.2466 28.8961 44.6577 28.2796",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.0457 34.75H62.879C69.7957 34.75 69.7957 31.2917 69.7957 27.8333C69.7957 20.9167 66.3374 20.9167 62.879 20.9167H49.0457C45.5874 20.9167 42.129 20.9167 42.129 27.8333C42.129 34.75 45.5874 34.75 49.0457 34.75Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.8065 56.1913H69.0148",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.8065 48.1591H69.0148",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.8065 66.4548H59.954",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 634147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.2622 42.7895L69.7718 55.2817C69.2963 55.7573 68.8208 56.6926 68.7257 57.3743L68.0441 62.146C67.7905 63.874 69.011 65.0788 70.7387 64.841L75.5098 64.1594C76.1756 64.0642 77.1107 63.5887 77.6021 63.1131L90.0925 50.6209C92.2482 48.4649 93.2627 45.9601 90.0925 42.7895C86.9224 39.6189 84.4179 40.6335 82.2622 42.7895Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M80.5054 44.3441C81.5948 48.2301 84.6353 51.2707 88.5376 52.3763",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingProjectEmpty);
export default __webpack_public_path__ + "static/media/ongoingProjectEmpty.78443b25f9a06a44253af97eabb267c2.svg";
export { ForwardRef as ReactComponent };